import React from "react";
import { useState, useEffect, useRef } from "react";
import { toggleMenu } from "../../utils/helpers";
import PageTitle from "../../components/PageTitle";
import Select from "react-select";
import Cookies from "js-cookie";
import { getApi } from "../../utils/api";
import { EMPLOYEE_LIST } from "../../config/Endpoints";
import SortableTable from "../../components/SortableTable";
import APPRAISAL from "../../config/api/appraisal";
import NoRecordsAvailable from "../../components/NoRecordsAvailable";
import { ThreeDots } from "react-loader-spinner";
import { toast } from "react-toastify";
import Pagination from "../../components/Pagination";
import axios from "axios";

const AppraisalReports = ({ title, description }) => {
  const [selectedEmployee, setSelectedEmployee] = useState(null);
  const [employees, setEmployees] = useState([]);
  const [loadingEmployees, setLoadingEmployees] = useState(true);
  const [downloading, setDownloading] = useState(false);
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [limit, setLimit] = useState(10);
  const accessToken = Cookies.get("accessToken");
  const columns = [
    {
      key: "employeeName",
      label: "Employee Name",
      sortable: true,
      render: (row) => row.employeeName,
    },
    {
      key: "email",
      label: "Email",
      sortable: true,
      render: (row) => row.email,
    },
    { key: "designation", label: "Designation" },
  ];
  const prevSelectedEmployee = useRef(selectedEmployee);

  useEffect(() => {
    // if previous was an employee and now cleared
    if (prevSelectedEmployee.current !== null && selectedEmployee === null) {
      handleFilter(); // fetch unfiltered data
    }
    // update ref for next render
    prevSelectedEmployee.current = selectedEmployee;
  }, [selectedEmployee]);

  useEffect(() => {
    const fetchEmployees = async () => {
      setLoadingEmployees(true);
      try {
        const res = await getApi(EMPLOYEE_LIST, accessToken);
        const employeeData = res?.data?.data || [];
        console.log(employeeData);
        const empOptions = employeeData.map((emp) => ({
          value: emp.id,
          label: emp.empName,
        }));

        setEmployees(empOptions);
      } catch (error) {
        setEmployees([]);
      } finally {
        setLoadingEmployees(false);
      }
    };

    fetchEmployees();
  }, []);

  useEffect(() => {
    handleFilter();
  }, [currentPage, limit]);

  // useEffect(() => {
  //   if (!selectedEmployee) return;

  //   const fetchAppraisal = async () => {
  //     setLoading(true);
  //     try {
  //       const res = await getApi(
  //         `${APPRAISAL.GET_APPRAISALS}/${selectedEmployee.value}`,
  //         accessToken,
  //       );
  //       setData(res?.data?.data || []);
  //     } catch {
  //       setData([]);
  //     } finally {
  //       setLoading(false);
  //     }
  //   };

  //   fetchAppraisal();
  // }, [selectedEmployee]);

  const handleFilter = async () => {
    setLoading(true);
    try {
      const url = selectedEmployee
        ? `${APPRAISAL.GET_APPRAISALS}/${selectedEmployee.value}?page=${currentPage - 1}&size=${limit}`
        : `${APPRAISAL.GET_APPRAISALS}/${0}?page=${currentPage - 1}&size=${limit}`;

      const res = await getApi(url, accessToken);

      const rows = (res?.data?.data || []).map((item) => ({
        employeeName: `${item.employee.firstName} ${item.employee.lastName || ""}`,
        email: item.employee.ccEmail,
        designation: item.employee.currentDesignation,
      }));

      setData(rows);
      setTotalPages(res?.data?.totalPages || 1);
    } catch {
      setData([]);
    } finally {
      setLoading(false);
    }
  };

  const handleDownload = async () => {
    setDownloading(true);
    try {
      const url = selectedEmployee
        ? `${APPRAISAL.EXPORT_APPRAISALS_REPORT}?employeeId=${selectedEmployee.value}`
        : APPRAISAL.EXPORT_APPRAISALS_REPORT;

      const res = await axios.get(url, {
        headers: {
          Authorization: `Bearer ${accessToken}`,
        },
        responseType: "blob",
      });

      const blob = new Blob([res.data], {
        type: res.headers["content-type"],
      });

      const link = document.createElement("a");
      link.href = window.URL.createObjectURL(blob);
      link.download = "appraisal-report.xlsx";
      document.body.appendChild(link);
      link.click();
      link.remove();
      window.URL.revokeObjectURL(link.href);
    } catch (err) {
      toast.error(err?.response?.data?.message || "Failed to download report.");
    } finally {
      setDownloading(false);
    }
  };

  const handlePageChange = (newPage) => {
    setCurrentPage(newPage);
  };
  const handleLimitChange = (e) => {
    setLimit(Number(e.target.value));
    setCurrentPage(1);
  };
  return (
    <div className="wrapper-body">
      <div className="page-heading">
        <div id="showMenuBtn" className="collapse-button" onClick={toggleMenu}>
          <span></span>
          <span></span>
          <span></span>
        </div>

        <PageTitle title={title} description={description} />
      </div>
      <div className="filters d-flex justify-content-between  gap-2 mb-3">
        <div className="col-md-4 ">
          <label className="label">Employee Name</label>
          <Select
            className="pr"
            options={employees}
            placeholder="Select Employee Name"
            value={selectedEmployee}
            onChange={(opt) => {
              setSelectedEmployee(opt);
              setCurrentPage(1);
            }}
            isClearable
          />
        </div>
        <div className="d-flex gap-2">
          <button className="theme-button" onClick={handleFilter}>
            Filter
          </button>

          <button
            className="theme-button"
            onClick={handleDownload}
            disabled={downloading}
          >
            {downloading ? (
              <ThreeDots height="20" width="50" radius="9" color="white" />
            ) : (
              "Download"
            )}
          </button>
        </div>
      </div>

      {loading ? (
        <div className="centered-loader">
          <ThreeDots height="100" width="100" radius="9" color="blue" />
        </div>
      ) : data.length === 0 ? (
        <NoRecordsAvailable />
      ) : (
        <div className=" p-3 mt-3">
          <SortableTable
            columns={columns}
            data={data}
            currentPage={currentPage}
            limit={limit}
          />
          <div className="row">
            <div className="col-md-3">
              <div>
                {/* Dropdown for selecting items per page */}
                <label htmlFor="itemsPerPage">Items per page </label>
                <select
                  id="itemsPerPage"
                  onChange={handleLimitChange}
                  value={limit}
                  className="border ms-3 w-25  p-2"
                >
                  <option value={5}>5</option>
                  <option value={10}>10</option>
                  <option value={20}>20</option>
                  <option value={30}>30</option>
                  <option value={40}>40</option>
                </select>
              </div>
            </div>
            <div className="col-md-9">
              <Pagination
                currentPage={currentPage}
                totalPages={totalPages}
                onPageChange={handlePageChange}
              />
            </div>
          </div>
        </div>
      )}

      {/* <div className="card p-3 mt-3">
        <SortableTable
          columns={columns}
          data={data}
          currentPage={1}
          limit={10}
        />
      </div> */}
    </div>
  );
};

export default AppraisalReports;
